import * as React from "react"

import { cn } from "../../lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, onChange, ...props }, ref) => {
    const innerRef = React.useRef<HTMLTextAreaElement | null>(null)

    const resize = React.useCallback(() => {
      const el = innerRef.current
      if (el) {
        el.style.height = "auto"
        el.style.height = el.scrollHeight + "px"
      }
    }, [])

    React.useEffect(() => {
      resize()
    }, [props.value, resize])

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      resize()
      onChange?.(e)
    }

    return (
      <textarea
        className={cn(
          "flex min-h-[32px] w-full rounded border border bg-background px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50 resize-none overflow-hidden",
          className
        )}
        ref={(node) => {
          innerRef.current = node
          if (typeof ref === "function") ref(node)
          else if (ref) ref.current = node
        }}
        onChange={handleChange}
        rows={1}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
